<template>
  <div>
    <div class="header-banner hotel-bg">
      <div class="overlay"></div>
      <img class="desktop-b" src="@/assets/img/banner/Frame-hotel.png" alt=""/>
      <img class="mobile-b" src="@/assets/img/banner/Header-banner-hotel-m.png" alt=""/>
    </div>
    <div class="container">
      <div class="content customs">
        <h2 class="head-title">{{ headTitle }}</h2>
        <p class="sub-title">{{ $t('INSERT_DETAILS_ON_IMAGE') }}</p>
        <h5 class="mini-title template">{{ $t('IPHONE_REMARK_BROWSER') }}
          <br>{{ $t('COPYRIGHT_WARNING') }}</h5>
        <div :class="['col-2', 'img', imgCustomClass]">
          <slot name="imageSlot"></slot>
        </div>
        <div class="col-2 form">
          <slot name="formSlot"></slot>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HotelArtworkLayout',
  props: {
    headTitle: {
      type: String,
      required: true,
    },
    imgCustomClass: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.col-2.img {
  border-radius: 10px;
  overflow: hidden;
}
.hotel-bg {
  background: url('@/assets/img/travel/Travel-photo-desktop04.jpg');
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
